(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/analyze/assets/draw-analysis.js') >= 0) return;  svs.modules.push('/components/sport/analyze/assets/draw-analysis.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const {
  useMemo,
  useState,
  useEffect,
  useCallback
} = React;
const {
  useSelector
} = ReactRedux;
const {
  EmptyNotice
} = svs.component.tipsenEmptyNotice;
const {
  AuthorProfile,
  EventAnalyses,
  TransferAnalyses
} = svs.component.analyze;
const {
  selectMatchAnalyses
} = svs.components.sportinfo.gameAnalysesRedux.selectors;
const {
  useDrawAnalyses
} = svs.components.sportinfo.gameAnalysesRedux.hooks;
const EMPTY_ARRAY = [];
const useGroupedAnalyses = drawAnalyses => {
  var _useMemo;
  const matchAnalyses = useSelector(selectMatchAnalyses);
  const matchAnalysesForDrawAnalyses = useMemo(() => drawAnalyses.map(_ref => {
    let {
      gameAnalysesIds
    } = _ref;
    return gameAnalysesIds.map(matchAnalysisId => matchAnalyses[matchAnalysisId]);
  }), [drawAnalyses, matchAnalyses]);
  const analysesGroupedOnEvent = (_useMemo = useMemo(() => {
    if (drawAnalyses.length > 0) {
      const analysesByEvent = new Array(drawAnalyses[0].gameAnalysesIds.length).fill(null).map(() => []);
      for (const matchAnalysis of matchAnalysesForDrawAnalyses.flat()) {
        analysesByEvent[matchAnalysis.eventNumber - 1].push(matchAnalysis);
      }
      return analysesByEvent;
    }
  }, [drawAnalyses, matchAnalysesForDrawAnalyses])) !== null && _useMemo !== void 0 ? _useMemo : EMPTY_ARRAY;
  return analysesGroupedOnEvent;
};
const useExpandableAnalyses = matchAnalyses => {
  const getNewExpanded = useCallback(() => {
    const expanded = {};
    for (const analyses of matchAnalyses) {
      const matchId = analyses[0].gameInfo.sportEvents[0];
      expanded[matchId] = false;
    }
    return expanded;
  }, [matchAnalyses]);
  const [expanded, setExpanded] = useState(() => getNewExpanded());
  useEffect(() => {
    const expanded = getNewExpanded();
    setExpanded(expanded);
  }, [getNewExpanded]);
  const toggleExpandedState = useCallback(matchId => {
    setExpanded(current => _objectSpread(_objectSpread({}, current), {}, {
      [matchId]: !current[matchId]
    }));
  }, []);
  return {
    expanded,
    toggleExpandedState
  };
};
const updateAuthors = drawAnalyses => () => drawAnalyses.map((_ref2, index) => {
  let {
    authorId
  } = _ref2;
  return {
    authorId,
    selected: index === 0
  };
});
const DrawAnalyses = _ref3 => {
  let {
    branding,
    drawId,
    setCoupon,
    eventTypeId,
    sportType
  } = _ref3;
  const drawAnalyses = useDrawAnalyses(drawId);
  const analysesByEvent = useGroupedAnalyses(drawAnalyses);
  const {
    expanded,
    toggleExpandedState
  } = useExpandableAnalyses(analysesByEvent);
  const [authors, setAuthors] = useState(updateAuthors(drawAnalyses));
  useEffect(() => {
    setAuthors(updateAuthors(drawAnalyses));
  }, [drawAnalyses]);
  if (drawAnalyses.length === 0 || authors.length === 0) {
    return React.createElement(EmptyNotice, {
      branding: branding
    }, "F\xF6r tillf\xE4llet har vi ingen spelanalys");
  }
  const handleToggleAuthor = index => {
    setAuthors(current => {
      const copy = current.slice(0);
      copy[index] = _objectSpread(_objectSpread({}, copy[index]), {}, {
        selected: !copy[index].selected
      });
      return copy;
    });
  };
  return React.createElement("div", {
    className: "route-play-draw-analyses"
  }, React.createElement("div", {
    className: "f-content"
  }, React.createElement("h3", null, drawAnalyses[0].title), React.createElement("div", {
    className: "margin-bottom-2",
    dangerouslySetInnerHTML: {
      __html: drawAnalyses[0].ingress
    }
  }), React.createElement("h3", {
    className: "f-550"
  }, "Kort om alla matcher")), React.createElement("div", {
    className: "margin-bottom-2"
  }, authors.map((_ref4, index) => {
    let {
      authorId,
      selected
    } = _ref4;
    return React.createElement(AuthorProfile, {
      authorId: authorId,
      key: authorId,
      noLabel: true,
      onToggle: () => {
        handleToggleAuthor(index);
      },
      selected: selected
    });
  })), React.createElement("ul", {
    className: "draw-analysis-analyses"
  }, analysesByEvent.map(matchAnalyses => {
    const matchId = matchAnalyses[0].gameInfo.sportEvents[0];
    return React.createElement(EventAnalyses, {
      analyses: matchAnalyses,
      authors: authors,
      branding: branding,
      eventTypeId: eventTypeId,
      isExpanded: expanded[matchId],
      key: matchAnalyses[0].id,
      onToggleExpand: toggleExpandedState,
      sportType: sportType
    });
  })), React.createElement(TransferAnalyses, {
    drawId: drawId,
    eventTypeId: eventTypeId,
    setCoupon: setCoupon,
    sportType: sportType
  }), React.createElement("div", {
    className: "f-content",
    dangerouslySetInnerHTML: {
      __html: drawAnalyses[0].body
    }
  }));
};
setGlobal('svs.component.analyze.DrawAnalyses', DrawAnalyses);

 })(window);